var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4834_19105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5016 4.50098V11.499C13.5016 14.2982 12.8018 14.998 10.0025 14.998H5.80371C3.00449 14.998 2.30469 14.2982 2.30469 11.499V4.50098C2.30469 1.70176 3.00449 1.00195 5.80371 1.00195H10.0025C12.8018 1.00195 13.5016 1.70176 13.5016 4.50098Z",
    stroke: "#0071BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30312 3.45215H6.50391",
    stroke: "#0071BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9011 12.9692C8.50017 12.9692 8.9858 12.4836 8.9858 11.8845C8.9858 11.2854 8.50017 10.7998 7.9011 10.7998C7.30204 10.7998 6.81641 11.2854 6.81641 11.8845C6.81641 12.4836 7.30204 12.9692 7.9011 12.9692Z",
    stroke: "#0071BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4834_19105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.c0b11c2a8761daca52ecb6bac1ca026c.svg";
export { ForwardRef as ReactComponent };